import { render } from "./notice-publish.vue?vue&type=template&id=473dcca8&scoped=true&ts=true"
import script from "./notice-publish.vue?vue&type=script&lang=ts"
export * from "./notice-publish.vue?vue&type=script&lang=ts"

import "./notice-publish.vue?vue&type=style&index=0&id=473dcca8&scoped=true&lang=scss"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473dcca8"]])

export default __exports__